'use strict';
const _ = require("lodash"),
    $ = require("jquery"),
    Backbone = require("backbone"),
    PubSub = require('./../PubSub')
    ;

module.exports = Backbone.Model.extend({
	defaults: {
		scriptLoaded: false,
		player_params: {
			uri: null,
			autoPlay: true,
			allowFullScreen: true,
			flashVars: { autoPlay: true },
      scoundrelMode: true
			// params: {
			// 	autoPlay: true,
			// 	allowFullScreen: true
			// }
		},
		container: null
	},
	currentVideo: null,
	/**
	 *
	 */
	initialize: function(attrs, options) {
        // While MTV figures out their issues with Android, we will attempt
        // to fix their performance.now function by placing it in the initialize function
        if(window.performance !== undefined && window.performance.now == undefined) {
        	window.performance.now = function() {
        		return new Date().getTime();
        	}
        }

        this.listenTo(PubSub, 'playVideo', this.playVideo.bind(this));

        this.listenTo(PubSub, 'removeVideoPlayer', function() {
        	if( this.currentVideo ) {
						try {
							this.currentVideo.destroy();
							this.currentVideo = null;
						} catch(e) {
							
						}
        	}
        }.bind(this));

        if(typeof EdgePlayer === 'object' && !_.isUndefined(window._edgePlayerApiReady)){
            this.set('scriptLoaded', true);
            return;
        } else {
						window.addEventListener( 'edgeplayer:PLAYLIST_METADATA', this.playerReady.bind(this) );
						window.addEventListener( 'edgeplayer', this.loadedScript.bind(this));
            this.loadScript(document, 'script', 'edgeplayer-api');
        }
	},
	/**
	 *
	 */
	loadScript: function(d, s, id) {
        var js;
        var fjs = d.getElementsByTagName(s)[0];
        if(d.getElementById(id)) return;

        js = d.createElement(s);
        js.id = id;
        js.src = 'https://player.mtvnservices.com/edge/player/3.1.10/edgeplayer.min.js';
        fjs.parentNode.insertBefore(js, fjs);
	},
	/**
	 *
	 */
	loadedScript: function() {
        this.set('scriptLoaded', true);
	},
	/**
	 *
	 */
	playVideo: function(video, player) {
		var video_params = _.clone(this.get('player_params'), true);
		video_params.uri = video;

		this.set({ player_params: video_params, container: player });

		var events = {
			STREAM_END: function () {
					PubSub.trigger('videoEnded');
			},
			FULL_SCREEN_CHANGE: function() {
					PubSub.trigger('resizeWindow');
			}
		};

		this.currentVideo = new EdgePlayer.Player(player, this.get('player_params'), events);

		this.registerListeners();
	},
	/**
	 * [registerListeners description]
	 * @return {[type]} [description]
	 */
	registerListeners: function() {
		this.currentVideo.on(EdgePlayer.Events.STREAM_END, this.mediaEnded.bind(this));

		// this.currentVideo.on('ready', this.playerReady.bind(this));
		// this.currentVideo.on('fullScreenChange', this.fullScreenChange);
	},
	/**
	 * [mediaEnded description]
	 * @return {[type]} [description]
	 */
	mediaEnded: function() {
    	// PubSub.trigger('resizeWindow');
    	PubSub.trigger('videoEnded');
	},
	/**
	 *
	 */
	fullScreenChange: function(event) {
		if(event.target.isFullScreen) return;

		// console.warn('fullScreenChange, resize window');
		PubSub.trigger('resizeWindow');
	},
	/**
	 *
	 */
	playerReady: function() {
		// play the video
		this.currentVideo.play();
	}
})



// WEBPACK FOOTER //
// ./app/scripts/models/pjs.js